import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BudgetStatsTable from './components/BudgetStatsTable';

export default function BudgetStatsPage() {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Budget Stats</h3>
          <h3 className="page-subhead subhead">All Accounts</h3>
        </Col>
      </Row>
      <Row>
        <BudgetStatsTable />
      </Row>
    </Container>
  );
}
